<template>
  <span>
    <router-link :to="'/production/items/' + id" v-if="userHasReadPermission(PermissionTypes.ProductionPermissionTypes.production) && !disabled" :target="target" :class="{'router-link-newtab': newTab}">
      {{name}}
    </router-link>
    <span v-else>
      {{name}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'LinkProductionPanel',
  props: {
    id: Number,
    name: String,
    newTab: {
      type: Boolean,
      default: true
    },
    disabled: Boolean
  },
  computed: {
    target() {
      if(this.newTab)
        return '_blank'

      return '_self'
    }
  }
}
</script>
